export default "__VITE_ASSET__DabAj$bx__$_?url__"